import {
  IStaffer,
  RootCollection,
} from '@principle-theorem/principle-core/interfaces';
import {
  CollectionReference,
  WithRef,
  all$,
  asColRef,
  shareReplayCold,
} from '@principle-theorem/shared';
import { sortBy } from 'lodash';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

export class ManagementStaffer {
  static col(): CollectionReference<IStaffer> {
    return asColRef<IStaffer>(RootCollection.ManagementStaff);
  }

  static all$(): Observable<WithRef<IStaffer>[]> {
    return all$(this.col()).pipe(
      map((staff) => sortBy(staff, ['user.name'])),
      shareReplayCold()
    );
  }
}
